<template>
  <div>
    <div class="form-group">
      <h3 class="font-w300 push-10">{{ labelFieldTitleAddDevice[actualLanguage] }}</h3>
      <h4 class="font-w300 push-10">{{ labelFieldTitleSticker[actualLanguage] }}</h4>
        
        <div class="row">
          <div class="col-xs-6">
            <label for="manufacturier">{{ labelFieldModuleId[actualLanguage] }}</label>
            <input :disabled="savingCar" type="text" v-model="deviceModel.deviceId">
          </div>

          <div v-if="displayKey" class="col-xs-6">
            <label for="manufacturier">{{ labelFieldModuleKey[actualLanguage] }}</label>
            <input :disabled="savingCar" type="text" v-model="deviceModel.deviceKey">
          </div>
        </div>
      
        <div class="row">
          <hr size="50">
          <div class="col-xs-12">
            <h6 class="font-w200 push-10">{{displayMessage}}</h6>
          </div>
        </div>
        
        
        <div v-if="deviceModel.deviceKey" class="row">
          <div class="col-xs-6">
          <button v-if="deviceModel.deviceKey" @click="testKey" class="btn btn-success btn-save" style="width: 160px" type="button" name="button">{{ labelFieldButtonCheck[actualLanguage] }}</button>
          </div>

          <div class="col-xs-6">
          <button v-if="codeConfirmed" @click="saveDevice" class="btn btn-success btn-save" style="width: 160px" type="button" name="button">{{ labelFieldButtonAdd[actualLanguage] }}</button>
          </div>

        </div>

      </div>
  </div>

</template>


<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'AddDeviceForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      savingCar: false,
      displayMessage: '',
      codeConfirmed: false,
      deviceIsSaving: false,
      displayKey: true,
      deviceModel: {
        deviceId: '',
        deviceKey: '',
      },

      actualLanguage : "FR",
      labelFieldTitleAddDevice: {FR: "Ajout d'appareil", EN: 'Add device'},
      labelFieldTitleSticker: {FR: "(Voir l'étiquette sous l'appareil)", EN:"(See the sticker on back panel of the device)"},
      labelFieldModuleId: {FR: "Identifiant de module de mesure", EN: 'Device ID'},
      labelFieldModuleKey: {FR: "Clef d'accès", EN: 'Access key'},
      labelFieldButtonCheck: {FR: 'Vérifier', EN: 'Validate'},
      labelFieldButtonAdd: {FR: "Ajouter le module", EN: 'Add module'},
      labelField: {FR: '', EN: ''},
    }
  },
  computed: {
    ...mapState('sessionStore', ['actualBundle']),
  },

  methods: {
  testKey() {
      this.displayMessage = '--';
      this.codeConfirmed = false;

      return this.$store.dispatch('devicesStore/validateDeviceId',this.deviceModel)
      .then((response) => {
         this.displayMessage = response.data.Message
         if (response.data.Code=='Fail'&& this.actualLanguage == "FR") this.displayMessage = 'Identifiant de module non valide!'
         if (response.data.Code=='Fail'&& this.actualLanguage == "EN") this.displayMessage = 'Wrong Module ID!'

         if (response.data.Code=='OK' && this.actualLanguage == "FR") this.displayMessage = "Code d'appareil valide, clef confirmée, appuyer sur Ajouter l'appareil"
         if (response.data.Code=='OK' && this.actualLanguage == "EN") this.displayMessage = 'Valid Module ID, key confirmed, press "Add device"'

         if (response.data.Code=='E00' && this.actualLanguage == "FR") this.displayMessage = 'Code de module valide, clef non valide'
         if (response.data.Code=='E00' && this.actualLanguage == "EN") this.displayMessage = 'Existing Module ID, Wrong access key'
         
         if (response.data.Code=='E01' && this.actualLanguage == "FR") this.displayMessage = 'Module déjà alloué'
         if (response.data.Code=='E01' && this.actualLanguage == "EN") this.displayMessage = 'Module already allocated'

         this.codeConfirmed = (response.data.Code=='OK');
         
        })
  },

  saveDevice() {
      this.displayMessage = 'Enregistrement';
      this.codeConfirmed = false;

      if (this.actualLanguage == "FR"){
        var deviceReferenceName = prompt("Nom de référence pour cet appareil", "Mon appareil");
      }else{
        var deviceReferenceName = prompt("Reference name for this device", "My device");
      }
      if(deviceReferenceName != null){
          this.deviceIsSaving = true
          var requestData = { 'postAction':'AddDeviceToBundle',
                              'bundleId': this.actualBundle.bundle_id,
                              'referenceName': deviceReferenceName,
                              'deviceId': this.deviceModel.deviceId,
                              'deviceKey': this.deviceModel.deviceKey,
                              }
          //console.log(requestData)      
          this.$store.dispatch('sessionStore/postDevice', requestData)
              .then((response) => {
                //console.log(response.data)
                this.deviceIsSaving = false
              if(response.data.Code=='OK'){
                  this.$store.dispatch('sessionStore/getGroupArborescence')
                  this.$store.dispatch('overlayStore/toggleModal',false)
                  }
                  else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
              })
      }   



  },

  saveDeviceOld() {
      this.displayMessage = 'Enregistrement';
      this.codeConfirmed = false;

      return this.$store.dispatch('devicesStore/addDeviceToProfile',this.deviceModel)
      .then((response) => {
         this.displayMessage = response.data.Message
         this.codeConfirmed = (response.data.Code!='OK');
         this.displayKey = (response.data.Code!='OK');
         if (response.data.Code=='OK') this.displayMessage = 'Module ajouté à votre profil, rafraichir la page et aller dans CONFIGURATION'
         if (response.data.Code=='E01') this.displayMessage = 'Clef non valide' 
         this.deviceModel.deviceKey = ''
         this.$store.dispatch('overlayStore/toggleModal',false)
         //if (response.data.Code=='OK') location.reload(true)
        })

  },
},

created() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }


}

</script>


// WEBPACK FOOTER //
// AddDeviceForm.vue?edafccfa